import { createReducer, on } from '@ngrx/store';
import { SitemapEntry } from '@wdx/clmi/clmi-swagger-gen';
import { CrudStatus } from '@wdx/shared/utils';
import * as extendedRouteActions from './extended-route.actions';

export const EXTENDED_ROUTE_FEATURE_KEY = 'extendedRoute';

export interface ExtendedRouteState {
    status: CrudStatus;
    sitemapEntry?: SitemapEntry;
    parentSitemapEntries?: SitemapEntry[];
    wholeSitemap?: SitemapEntry[];
    isAdminArea?: boolean;
}

export const initialState: ExtendedRouteState = {
    status: CrudStatus.Initial,
    sitemapEntry: undefined,
    parentSitemapEntries: undefined,
    wholeSitemap: undefined,
    isAdminArea: undefined,
};

export const extendedRouteReducer = createReducer(
    initialState,
    on(
        extendedRouteActions.updateExtendedRouteState,
        (
            state,
            {
                status,
                sitemapEntry,
                parentSitemapEntries,
                wholeSitemap,
                isAdminArea,
            },
        ) => ({
            ...state,
            status,
            ...(sitemapEntry !== undefined ? { sitemapEntry } : {}),
            ...(parentSitemapEntries !== undefined
                ? { parentSitemapEntries }
                : {}),
            ...(wholeSitemap !== undefined ? { wholeSitemap } : {}),
            ...(isAdminArea !== undefined ? { isAdminArea } : {}),
        }),
    ),
    on(extendedRouteActions.clearExtendedRouteState, () => initialState),
);
